import { gql, useMutation } from '@apollo/client';
import type { MutationResult } from '@livecontrol/scheduler/store';
import { useCallback } from 'react';
// import * as Dbx from './dbx';

interface TData {
  scheduleSoftwareUpdate?: {
    id: string;
  }[];
}

interface TVariables {
  input: {
    location_ids: string[];
    schedules: {
        update_url_id: number;
        next_update_at?: string; // Date
    }[];
  };
}

interface Args {
  locations: string[];
  schedules: {
    id: string;
    updateAt: Date;
  }[];
}

const MUTATION = gql`
mutation ScheduleSoftwareUpdate($input: UpsertEncoderUpdateInput!) {
  scheduleSoftwareUpdate(input: $input) {
    id
  }
}
`;

export const useUpdateDevicesLater = (): [
  (args: Args) => Promise<{ id: string }[] | undefined>,
  MutationResult<{ id: string }[], 'id'>
] => {
  const [mutate, { data, loading, error, called }] = useMutation<TData, TVariables>(MUTATION);

  return [
    useCallback(async (args: Args) => {
      let ids_: { id: string }[] | undefined;

      try {
        const variables = {
          input: {
            location_ids: args.locations,
            schedules: args.schedules.map(installer => ({
              update_url_id: Number(installer.id)
            }))
          }
        };

        if (!variables.input.location_ids.length || !variables.input.schedules.length) {
          return undefined;
        }

        const response = await mutate({ variables });

        ids_ = response.data?.scheduleSoftwareUpdate?.map(({ id }) => ({ id }))
          .filter((v): v is { id: string } => !!v.id);
      } catch {
        //
      }

      return ids_;
    }, [mutate]),
    {
      called,
      loading,
      id: data?.scheduleSoftwareUpdate
        ?.map(({ id }) => ({ id }))
        .filter((v): v is { id: string } => !!v.id),
      error
    }
  ];
};
